import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { LoginModel } from '../models/Login.model'
import {
  RegisterCheckPoliciesModel,
  RegisterCodeModel,
  RegisterFinishRequestModel,
  RegisterFormData,
  RegisterPhoneModel,
} from '../models/Register.model'
import { UserProfileResponse } from '../models/User.model'
import AuthService from './AuthService'

interface AppState {
  user: UserProfileResponse | null
  isAuth: boolean
}

const initialState: AppState = {
  user: null,
  isAuth: false,
}

export const loginThunk = createAsyncThunk(
  'auth/loginThunk',
  async (form: LoginModel, { rejectWithValue }) => {
    try {
      return await AuthService.login(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const registrationThunk = createAsyncThunk(
  'auth/registrationThunk',
  async (form: RegisterFormData, { rejectWithValue }) => {
    try {
      return await AuthService.registration(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const checkPoliciesThunk = createAsyncThunk(
  'auth/checkPoliciesThunk',
  async (form: RegisterCheckPoliciesModel, { rejectWithValue }) => {
    try {
      return await AuthService.checkPolicies(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const emailVerifyThunk = createAsyncThunk(
  'auth/emailVerifyThunk',
  async (form: RegisterCodeModel, { rejectWithValue }) => {
    try {
      return await AuthService.emailVerify(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const enterPhoneThunk = createAsyncThunk(
  'app/enterPhoneThunk',
  async (form: RegisterPhoneModel, { rejectWithValue }) => {
    try {
      return await AuthService.enterPhone(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const smsVerifyThunk = createAsyncThunk(
  'auth/smsVerifyThunk',
  async (form: RegisterCodeModel, { rejectWithValue }) => {
    try {
      return await AuthService.smsVerify(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const registerFinishThunk = createAsyncThunk(
  'auth/registerFinishThunk',
  async (form: RegisterFinishRequestModel, { rejectWithValue }) => {
    try {
      return await AuthService.registerFinish(form)
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

export const getUserThunk = createAsyncThunk(
  'auth/getUserThunk',
  async (_, { rejectWithValue }) => {
    try {
      return await AuthService.getUser()
    } catch (errors) {
      return rejectWithValue(errors)
    }
  },
)

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onLogout(state) {
      state.isAuth = false
      state.user = null
    },
  },

  extraReducers: builder => {
    builder
      .addCase(registerFinishThunk.fulfilled, (state, action) => {
        state.isAuth = !!action.payload.token
      })

      .addCase(loginThunk.fulfilled, (state, action) => {
        state.isAuth = !!action.payload.token
      })

      .addCase(getUserThunk.fulfilled, (state, action) => {
        state.isAuth = true
        state.user = action.payload
      })
    // .addCase(getGeolocationThunk.rejected, state => {
    //   state.geo = null
    // })
  },
})

export const { actions, reducer } = authSlice
export const { onLogout } = actions
